export const LAYERED_MAP_MODAL_MAX_WIDTH = 850;
